import React, { useState, useEffect } from "react";
import { useHistory, Redirect, Link, } from "react-router-dom";
import {
    Button,
} from "react-bootstrap";
import Loader from "react-loader-spinner";
import axios from "axios";
import { uAPIlocal } from './lib/config';
import queryString from "query-string";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";

import {
    loadCaptchaEnginge,
    LoadCanvasTemplate,
    LoadCanvasTemplateNoReload,
    validateCaptcha,
} from "react-simple-captcha";
import { v4 as uuidv4 } from "uuid";
import frame2 from "../assets/frame2.svg";
import logo from "../assets/logo-klinik.png";
import logo2 from "../assets/logo-rujukan.png";
import frame1 from "../assets/frame1.svg"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useCookies } from "react-cookie";
import parse from "html-react-parser";
import Cookies from 'js-cookie';

export default function Login() {

    const instance = axios.create({
        withCredentials: true,
    });

    const location = useHistory().location;
    const history = useHistory();
    const [cookies, setCookie, removeCookie] = useCookies();
    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
    });

    const [redirctTo, setRedirctTo] = React.useState(false);


    useEffect(() => {
        console.log("ini history", location);
        if (Cookies.get('biomedika-login') == undefined) {
            setRedirctTo(true);
        }
    });

    async function goTo(x) {
        if (x == 1) {
            localStorage.setItem("page", "klinik");
            if (Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 3) {
                setTimeout(() => {
                    history.push("/admin/master-record");
                }, 1000);
            } else if (Cookies.get('biomedika-level') == 2 || Cookies.get('biomedika-level') == 4) {
                setTimeout(() => {
                    history.push("/admin/master-exam");
                }, 1000);
            } else {
                setTimeout(() => {
                    history.push("/admin/master-record");
                }, 1000);
            }

        } else if (x == 2) {
            localStorage.setItem("page", "rujukan");
            if (Cookies.get('biomedika-level') != 2) {
                setTimeout(() => {
                    history.push("/pasien");
                }, 1000);
            } else if (Cookies.get('biomedika-level') == 2 && JSON.parse(localStorage.getItem("_log")).lt_ == 2) {
                setTimeout(() => {
                    history.push("/sregistration");
                }, 1000);
            } else if (Cookies.get('biomedika-level') == 2 && JSON.parse(localStorage.getItem("_log")).lt_ != 2) {
                setTimeout(() => {
                    history.push("/registration");
                }, 1000);
            }

        } else { }
    }

    if (redirctTo) {
        localStorage.setItem("loginStatus", "logout");
        localStorage.setItem("_type", 2);
        return (<Redirect
            to={{
                pathname: "/",
            }} />)
    } else { }

    // if (cookies["biomedika-login"] != null && Cookies.get('biomedika-level')) {
    //     return (
    //         <Redirect
    //             to={{
    //                 pathname: Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 3 ? "/admin/master-record" : "/admin/master-exam",
    //             }}
    //         />
    //     );
    // }

    return (
        <>

            <div className="container" style={{ maxWidth: '100%' }}>
                <div className="content" >
                    <div className="row">
                        <div className="col-6 p-2">
                            <div className="col-12 text-center rounded p-0" style={{ marginBottom: '20px' }}>
                                <div id="btnMenu1" onClick={() => goTo(1)} className="btn btn-outline-success" >
                                    <img alt='image2' className="logo-new" src={logo} />
                                     <span >Klinik</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 p-2">
                            <div className="col-12 text-center rounded p-0" style={{ marginBottom: '20px' }}>
                                <div id="btnMenu2" onClick={() => goTo(2)} className="btn btn-outline-info">
                                    <img alt='image2' className="logo-new" src={logo2} />
                                    <span >Rujukan</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );


}
